import { Pipe, PipeTransform, Sanitizer } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Pipe({
  name: 'picture'
})
export class PicturePipe implements PipeTransform {

  constructor(private _sanitizer: DomSanitizer){

  }
  
  transform(data: string, mediaType: string): SafeUrl {
    return this._sanitizer.bypassSecurityTrustUrl(`data:${mediaType};base64,${data}`);
  }

}
